import { useTranslations } from "next-intl";
import { useState } from "react";
import { Button } from "@components/core";
import useCustomizableCloset from "@hooks/use-customizable-closet";
import ClosetItemsList from "@components/core/ClosetItemsList";
import CheckReturnParcelAnimation from "../CheckReturnParcelAnimation";
import ReturnMyClosetGuide from "./ReturnMyClosetGuide";
import ClosetPromoBannerContainer from "./ClosetPromoBannerContainer";
import ClosetShortReview from "@components/views/Closets/ClosetLayout/ClosetShortReview";

function DrawerEligibleToNextCloset() {
  const t = useTranslations("common");

  const currentCloset = useCustomizableCloset();

  const [partToShow, setPartToShow] = useState("defaultChoice");

  function startAnimation() {
    setPartToShow("checkReturnAnimation");
  }

  if (partToShow === "checkReturnAnimation") return <CheckReturnParcelAnimation />;
  if (partToShow === "returnMyClosetGuide")
    return <ReturnMyClosetGuide startAnimation={startAnimation} />;

  return [
    <div
      className="d-flex flex-column drawer-body"
      key="drawer-received-body"
    >
      <div className="d-flex flex-column align-items-center bg-white py-3 px-4 text-center">
        <h5 className="mb-2 px-2">{t("drawer.modal_closet_received.ready_for_next_closet")}</h5>
        <p className="px-2 text-gray mb-0">
          {t("drawer.modal_closet_received.you_will_be_able_to_choose")}
        </p>
        {currentCloset.mail_box_picking_date_requested_at && (
          <p className="px-2 text-gray mb-0">
            {t("drawer.modal_closet_received.mail_box_picking_request_done")}
          </p>
        )}

        <Button
          variant="ghost-primary"
          trackingName="drawerReceived_CheckMyReturn"
          onClick={startAnimation}
          className="mt-2"
        >
          {t("drawer.modal_closet_received.check_my_parcel")}
        </Button>
      </div>

      <ClosetPromoBannerContainer />

      <ClosetShortReview
        closet={currentCloset}
        origin="drawer"
        className="mt-2 px-2"
      />

      <div className="mt-2 mx-2">
        <ClosetItemsList closet={currentCloset} />
      </div>
    </div>,
    <div
      className="bg-white p-3 w-100 border-top border-light mt-2"
      key="drawer-received-footer"
    >
      <Button
        trackingName="drawerReceived_ReturnMyCloset"
        fullWidth
        onClick={() => setPartToShow("returnMyClosetGuide")}
      >
        {t("drawer.modal_closet_received.return_my_closet")}
      </Button>
    </div>,
  ];
}

export default DrawerEligibleToNextCloset;
